import {
  ADDRS_SEARCH_START,
  ADDRS_SEARCH_SUCCESS,
  ADDRS_SEARCH_FAIL,
  SUGST_ADDRS_SEARCH,
  SUGST_ADDRS_SEARCH_SUCCESS,
  SUGST_ADDRS_SEARCH_FAIL
} from './actions'
import produce from 'immer'

const initialState = {
  isLoadingSuggestAddresses: false,
  suggestAddressesError: null,
  suggestionsGeneral: [],
  isLoadingAddressSearch: false,
  addressSearchError: null,
  foundAddresses: [],
  siteAddress: null,
  addressesHasSearched: false
}

const reducer = (state = initialState, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case ADDRS_SEARCH_START: {
        draft.isLoadingAddressSearch = true
        draft.addressSearchError = null
        draft.foundAddresses = []
        draft.addressesHasSearched = true
        return
      }
      case ADDRS_SEARCH_SUCCESS: {
        draft.isLoadingAddressSearch = false
        draft.addressSearchError = null
        draft.foundAddresses = action.foundAddresses
        return
      }
      case ADDRS_SEARCH_FAIL: {
        draft.isLoadingAddressSearch = false
        draft.addressSearchError = action.error
        draft.foundAddresses = []
        return
      }
      case SUGST_ADDRS_SEARCH: {
        draft.isLoadingSuggestAddresses = true
        draft.suggestAddressesError = null
        draft.suggestionsGeneral = []
        draft.foundAddresses = []
        draft.siteAddress = null
        draft.addressesHasSearched = false
        return
      }
      case SUGST_ADDRS_SEARCH_SUCCESS: {
        draft.isLoadingSuggestAddresses = false
        draft.suggestAddressesError = null
        draft.suggestionsGeneral = action.suggestedAddresses.suggestionsGeneral
        draft.siteAddress =
          action.suggestedAddresses?.siteAddress != null
            ? {
                fullAddress: action.suggestedAddresses.siteAddress.address,
                coordinates:
                  action.suggestedAddresses.siteAddress.addressCoordinates
              }
            : null
        return
      }
      case SUGST_ADDRS_SEARCH_FAIL: {
        draft.isLoadingSuggestAddresses = false
        draft.suggestAddressesError = action.error
        draft.suggestionsGeneral = []
        draft.siteAddress = null
        return
      }
    }
  })
}

export { reducer }
